import { render, staticRenderFns } from "./split-image.vue?vue&type=template&id=4ce5b7a0&scoped=true"
import script from "./split-image.vue?vue&type=script&lang=js"
export * from "./split-image.vue?vue&type=script&lang=js"
import style0 from "./split-image.vue?vue&type=style&index=0&id=4ce5b7a0&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce5b7a0",
  null
  
)

export default component.exports